import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bill-conn" }
const _hoisted_2 = { class: "bill-conn__name" }
const _hoisted_3 = { class: "bill-conn__field" }
const _hoisted_4 = { class: "bill-conn__field" }
const _hoisted_5 = { class: "bill-conn__cap" }
const _hoisted_6 = { class: "bill-conn__field" }
const _hoisted_7 = { class: "bill-conn__cap" }
const _hoisted_8 = { class: "bill-conn__bar" }

import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { EditableConnection } from "@/composables/useBillConnectionsEditor";
import { barWidth } from "../bill-format";


export default /*@__PURE__*/_defineComponent({
  __name: 'BillConnectionIncome',
  props: {
    row: {},
    percentError: { type: Boolean },
    amountError: { type: Boolean },
    payedError: { type: Boolean }
  },
  emits: ["input", "blurField", "detach", "moveInfo"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.row.income?.VendorCode || _ctx.$t('bill_income_placeholder')), 1),
    _createVNode(AppTooltip, {
      text: _ctx.$t('movement_info')
    }, {
      activator: _withCtx(() => [
        _createVNode(AppIcon, {
          class: "bill-conn__move",
          name: "info-circle-outline",
          width: "14px",
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('moveInfo')))
        })
      ]),
      _: 1
    }, 8, ["text"]),
    _createElementVNode("span", _hoisted_3, [
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "bill-conn__cap" }, "%:", -1)),
      _createVNode(AppInput, {
        class: "bill-conn__inp",
        type: "number",
        "model-value": _ctx.row.AmountPercentText,
        "show-clear-button": false,
        error: !_ctx.row.AmountPercentValid || !!_ctx.percentError,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => emit('input', 0, v)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (emit('blurField')))
      }, null, 8, ["model-value", "error"])
    ]),
    _createElementVNode("span", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('amount_lower')) + ":", 1),
      _createVNode(AppInput, {
        class: "bill-conn__inp",
        type: "number",
        "model-value": _ctx.row.AbsoluteAmountText,
        "show-clear-button": false,
        error: !_ctx.row.AbsoluteAmountValid || !!_ctx.amountError,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = (v) => emit('input', 1, v)),
        onBlur: _cache[4] || (_cache[4] = ($event: any) => (emit('blurField')))
      }, null, 8, ["model-value", "error"])
    ]),
    _createElementVNode("span", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('debit_lower')) + ":", 1),
      _createVNode(AppInput, {
        class: "bill-conn__inp",
        type: "number",
        "model-value": _ctx.row.PayedAmountText,
        "show-clear-button": false,
        error: !_ctx.row.PayedAmountValid || !!_ctx.payedError,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = (v) => emit('input', 2, v)),
        onBlur: _cache[6] || (_cache[6] = ($event: any) => (emit('blurField')))
      }, null, 8, ["model-value", "error"])
    ]),
    _createElementVNode("span", _hoisted_8, [
      _createElementVNode("span", {
        class: "bill-conn__bar-fill",
        style: _normalizeStyle({ width: _unref(barWidth)(_ctx.row.PayedPercent) })
      }, null, 4)
    ]),
    _createVNode(AppTooltip, {
      text: _ctx.$t('ui_detach')
    }, {
      activator: _withCtx(() => [
        _createVNode(AppIcon, {
          class: "bill-conn__detach",
          name: "close",
          width: "10px",
          color: "#D2D2D2",
          "hover-color": "#499259",
          cursor: "pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('detach')))
        })
      ]),
      _: 1
    }, 8, ["text"])
  ]))
}
}

})